module.exports = "/cyber/_next/static/images/loginSteam-ea97e39905e991aac281ab5eb71c2731.jpg";